import { render, staticRenderFns } from "./IconCards.vue?vue&type=template&id=2ac0efbd&scoped=true&"
import script from "./IconCards.vue?vue&type=script&lang=ts&"
export * from "./IconCards.vue?vue&type=script&lang=ts&"
import style0 from "./IconCards.vue?vue&type=style&index=0&id=2ac0efbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0efbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
